import React, { useContext } from "react";
import { appContext } from "../App";
import SearchStats from "./SearchStats";

const defaultSort = `_score desc`;

function SearchHeader() {
  const { result, sort, searching, setSort } = useContext(appContext);

  const handleSortChange = (event: React.ChangeEvent<{ value: string }>) => {
    if (event.currentTarget.value) {
      setSort(event.currentTarget.value);
    } else {
      setSort(defaultSort);
    }
  };
  return (
    <div className="row sort_container" style={{ paddingTop: "20px" }}>
      <div className="col-xs-12 col-sm-7 col-md-8">
        <SearchStats
          searching={searching}
          found={result?.hits?.total.value || 0}
          more={result?.hits?.total.relation === "gte"}
        />
      </div>
      <div className="col-xs-12 col-sm-5 col-md-4">
        <div className="form-horizontal">
          <div className="form-group">
            <label className="control-label col-xs-2">Sort</label>
            <div className="col-xs-10">
              <select
                name="sortby"
                className="form-control"
                onChange={handleSortChange}
                defaultValue={sort || defaultSort}
              >
                <option value="_score desc">Most Popular</option>
                <option value="name.keyword asc">Name</option>
                <option value="sku.keyword asc">SKU</option>
                <option value="default_price asc">Lowest Price</option>
                <option value="default_price desc">Highest Price</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchHeader;
